import { render, staticRenderFns } from "./SectionTextMiddleButtons.vue?vue&type=template&id=2c18f7d3&scoped=true"
import script from "./SectionTextMiddleButtons.vue?vue&type=script&lang=js"
export * from "./SectionTextMiddleButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18f7d3",
  null
  
)

export default component.exports